import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { SwiperConfigInterface } from "ngx-swiper-wrapper";
import { constApi } from "src/environments/constApi";
import { ProductService } from "../services/product.service";

@Component({
  selector: "app-filial-carousel",
  templateUrl: "./filial-carousel.component.html",
  styleUrls: ["./filial-carousel.component.sass"],
})
export class FilialCarouselComponent implements OnInit {
  constructor(
    private productService: ProductService,
    private router: Router,
    private spinner: NgxSpinnerService
  ) {}
  public config: SwiperConfigInterface;
  filialArray: any[] = [];
  async ngOnInit(): Promise<void> {
    this.filialArray = [];
  }
  async obtenerFiliales() {
    return await this.productService
      .getParam(constApi.FILIALISTEC, [])
      .toPromise()
      .catch((error: any) => {});
  }
  async ngAfterViewInit() {
    this.filialArray = [];
    this.cargarConfig();
  }
  selectFilial(item: any) {
    this.router.navigate(["/home/products/", 0, 0, 0, item.Marca, 0, 0, 1]);
  }
  async cargarConfig() {
    this.spinner.show();
    let filial: any = await this.obtenerFiliales().then((x) => x.body);
    this.filialArray = filial;
    this.filialArray.forEach((x) => {
      if (x.UrlLogo == "") {
        x.UrlLogo =
          "https://www.solonohio.org/ImageRepository/Document?documentID=11108";
      }
    });
    setTimeout(() => {
      this.config = {
        observer: true,
        slidesPerView: 4,
        spaceBetween: 16,
        keyboard: true,
        navigation: true,
        pagination: false,
        grabCursor: true,
        loop: true,
        preloadImages: false,
        lazy: true,
        breakpoints: {
          1500: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
          1000: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          500: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        },
      };
      this.spinner.hide();
    }, 100);
  }
}
